import { render, staticRenderFns } from "./CreateShipModal.vue?vue&type=template&id=1dc06b21&scoped=true&"
import script from "./CreateShipModal.vue?vue&type=script&lang=js&"
export * from "./CreateShipModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateShipModal.vue?vue&type=style&index=0&id=1dc06b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc06b21",
  null
  
)

export default component.exports